import IconAssess from "@material-ui/icons/Assessment";
import { Parser } from "json2csv";
import { Button as DefaultButton } from "ra-ui-materialui/lib/button";
import React from "react";
import { DataProviderProxy, useNotify } from "react-admin";
import fileDownload from "js-file-download";
import { useSelector } from "react-redux";
import { ReduxState } from "ra-core";

interface IAssignmentReportButton {
  provider: DataProviderProxy;
  busSchedulePlansWithWaveName: any;
  startDate: string;
  endDate: string;
}

const PassengerReportButton = ({
  provider,
  busSchedulePlansWithWaveName,
  startDate,
  endDate,
}: IAssignmentReportButton) => {
  const { customGetListWithStaticParams } = provider;
  const notify = useNotify();
  const navMode = useSelector((state: ReduxState) => state.navMode);

  const downloadCSV = async () => {
    const assignmentReports = busSchedulePlansWithWaveName.map(
      async (busSchedulePlan: any) => {
        const assignmentSummaryResponse = await customGetListWithStaticParams(
          `summaries/assignment?BusSchedulePlanId=${busSchedulePlan.id}&StartDate=${startDate}&EndDate=${endDate}`
        );

        return {
          waveName: busSchedulePlan.waveName,
          ...assignmentSummaryResponse.data,
        };
      }
    );

    Promise.all(assignmentReports).then((data: any) => {
      if (data.length === 0) {
        notify("There are no assignment.", "warning");
        return;
      }

      const parser = new Parser();

      fileDownload(
        parser.parse(data),
        `Assignment Report ${navMode.school.name} (${startDate} - ${endDate}).csv`
      );
    });
  };

  return (
    <DefaultButton onClick={downloadCSV}>
      <>
        <IconAssess />
        <span>Download Assignment Report</span>
      </>
    </DefaultButton>
  );
};

export default PassengerReportButton;
